import { BaseDto } from './base.dto';
import { MerchantDto } from './merchant.dto';
import { StockDto } from './stock.dto';
import { SupplierDto } from './supplier.dto';

export class StockParDto extends BaseDto {
    minQtyMerchant: number;
    maxQtyMerchant: number;
    stock: StockDto;
    stockId?: number;
    merchant: MerchantDto;
    merchantId?: number;
    supplier: SupplierDto;
    supplierId?: number;
    isMasterLevel: boolean;
}


export class StockParCreateUpdateDto extends BaseDto {
    minQtyMerchant?: number;
    maxQtyMerchant?: number;
    isMasterLevel?: boolean;
    stockId?: number;
    merchantId?: number;
    supplierId?: number;
}
